import * as React from 'react';
export const IcEndChat = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.88 7.12c.39.39 1.02.39 1.41 0l.71-.71.71.71a.996.996 0 101.41-1.41L20.41 5l.71-.71a.996.996 0 10-1.41-1.41l-.71.71-.71-.71a.996.996 0 10-1.41 1.41l.71.71-.71.71a.996.996 0 000 1.41zm4.87 2.05c-.79.52-1.73.83-2.75.83a5.002 5.002 0 01-4.9-6H9c-3.87 0-7 3.13-7 7 0 3.53 2.61 6.43 6 6.92V20c0 1.24 1.41 1.94 2.4 1.2l4.27-3.2H15c3.87 0 7-3.13 7-7 0-.63-.09-1.25-.25-1.83z'
      fill='currentColor'
    />
  </svg>
);
